<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>App启动页配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select
          :value="query.type"
          @change="handleQueryChange('type', $event)"
          placeholder="请选择"
        >
          <el-option
            v-for="item in bannerTypes"
            :key="item.type"
            :label="item.message"
            :value="item.type"
          ></el-option>
        </el-select>
        <el-select
          :value="query.language"
          @change="handleQueryChange('language', $event)"
          placeholder="请选择"
        >
          <el-option
            v-for="item in languageList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          :value="query.platform"
          @change="handleQueryChange('platform', $event)"
          placeholder="请选择"
        >
          <el-option
            v-for="item in platformTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <create-banner @refresh="refreshList"></create-banner>
      </div>
      <banner-list @refresh="refreshList"></banner-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import BannerList from './components/list';
import CreateBanner from './components/create';
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'BannerSetting',
  components: {
    BannerList,
    CreateBanner
  },
  computed: {
    ...mapState('appFunctionalPageSetting', [
      'platformTypeList',
      'languageList',
      'query',
      'bannerTypes'
    ])
  },
  methods: {
    ...mapActions('appFunctionalPageSetting', ['list', 'getbannerType']),
    ...mapMutations('appFunctionalPageSetting', ['changeQuery']),
    refreshList() {
      this.list(this.query);
    },
    handleQueryChange(type, value) {
      this.changeQuery({
        ...this.query,
        [type]: value
      });
      this.refreshList();
    }
  },
  created() {
    this.list(this.query);
    this.getbannerType();
  }
};
</script>

<style lang="less" scoped></style>
